import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'
import { queryString } from '@/utils'

import mutations from '@/store/mutation-types'

import data from '@/store/modules/data'
import share from '@/store/modules/share'

Vue.use(Vuex)

const params = queryString(location.search)
const store = new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state: {
    API_BASE_URL: `${config.api_base_url}campaigns/`,
    SHARE_API_BASE_URL: config.share_api_base_url,
    urlParams: params,
    musicPlaying: false
  },
  mutations: {
    [ mutations.update.MUSIC_PLAYING_STATUS ] (state) {
      state.musicPlaying = !state.musicPlaying
    }
  },
  modules: {
    data,
    share
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js